











// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
//import EditMarques from '@/components/flux/edit/EditMarques.vue'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux'
import { TypeOffre } from '@/enum/TypeOffre'
import { getDefaultAloBase } from '@/models/alo/AloBase'
import { toGroupDictionnaryNumber, toNumberDictionary, toStringLookup, toNumberLookup } from '@/utils/groupBy'
import { ExportCatalogType } from '@/enum/ExportCatalogType'
import cloneDeep from 'clone-deep'
import Edit from '@/components/flux/edit/EditMetas.vue'

@Component({
  name: 'ReadFeedProduit',    
  components:{Edit},  
  props: {
    loading:{
      type:Boolean,
      default:false
    },
    flux:{
      type:Object,
      default:getDefaultAloFlux
    },
    editable:{
      type:Boolean,
      default:true      
    },
    catalogueType:{
      type:String,
      required:true
    }
  }
})
export default class ReadFeedProduit extends Vue {
  
  private flux!:AloFlux
  private loading!:boolean
  private catalogueType!:ExportCatalogType
  private saving:boolean = false  

  private get title() {
    return this.catalogueType == ExportCatalogType.Offers?"Exporter un feed produit":"Exporter un feed famille"
  }

  private get otherTypeMeta() {
    return this.catalogueType == ExportCatalogType.Offers?ExportCatalogType.Tree:ExportCatalogType.Offers
  }

  private get enable() {
    return (this.flux.flxCatalogTyp == ExportCatalogType.OffersAndTree || this.flux.flxCatalogTyp == this.catalogueType)
  }    

  private get fluxStatus() {
    return this.$store.myGetters.fluxStatus        
  }

  private set enable(newValue) {    
    const modifiedFlux = cloneDeep(this.flux)
    if(newValue) {       
      modifiedFlux.flxCatalogTyp = modifiedFlux.flxCatalogTyp == this.otherTypeMeta?ExportCatalogType.OffersAndTree:this.catalogueType      
    }
    else {
      modifiedFlux.flxCatalogTyp = modifiedFlux.flxCatalogTyp == ExportCatalogType.OffersAndTree?this.otherTypeMeta:ExportCatalogType.None
    }
    this.saving = true
    this.$store.myActions.ADM_FLUX_SAVE_REQUEST(modifiedFlux).finally(()=>{
      this.saving = false
    })  
  }  

  get metaGroups() {    
    return this.$store.myGetters.metaGroups
  }

  get groupList() { 
    return this.$store.myGetters.metaGroupsList.filter(g => !!this.selectedMetasByGroup[g.id])
  }

  get metasList(){
    return this.$store.myGetters.metasList
  }
  
  get fluxMetaDic(){
    return toNumberDictionary(this.flux.metaIds,it => it)
  }

  get selectedMetasByGroup(){
    return toNumberLookup(this.metasList.filter(m => m.mtaFluxTyp == this.catalogueType && !!this.fluxMetaDic[m.id]),m=>m.mtgId) 
  }

  edit() { 
    (this.$refs.edit as Edit).edit(this.flux) 
  }

  created(){
    this.$store.myActions.CATALOGUE_META_ENSURE()
  }


}
